import cx from 'clsx';
import { IPaymentInfoProps } from '@paylink/types';

import styles from './PaymentInfo.module.scss';
import AmountSummary from '../amountSummary/AmountSummary';
import PaymentFor from '../paymentFor/PaymentFor.view';
import Footer from '../footer/Footer.view';
import Header from '../header/Header';

const PaymentInfo = ({
	merchantName,
	logoId,
	amount,
	description,
	subscriptionDetails,
	isMobile = false,
}: IPaymentInfoProps) => (
	<div
		className={cx(
			' height100 relative',
			styles.leftPanelWrapper,

			{
				[styles.leftPanelWrapperMobile]: isMobile,
				p2: !isMobile,
			},
		)}
	>
		<div
			className={cx(
				'd-flex flex-column items-center bg-white height100 border-radius4 border1 border-grey2  overflow-hidden',
				{
					gap6: !isMobile,
					gap4: isMobile,
				},
			)}
		>
			<Header
				logoId={logoId}
				merchantName={merchantName}
				isMobile={isMobile}
				className="pl6 pr2"
			/>

			<div
				className={cx('d-flex flex-column flex1 width100 py0 px4 relative', {
					'mb4 gap4': isMobile,
					gap6: !isMobile,
				})}
			>
				<AmountSummary
					amount={amount}
					subscriptionDetails={subscriptionDetails}
					isMobile={isMobile}
				/>

				{description && (
					<PaymentFor description={description} isMobile={isMobile} />
				)}
			</div>

			{!isMobile && <Footer />}
		</div>
	</div>
);

export default PaymentInfo;
